import {useEffect, useState} from "react";
import * as React from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {QueryClient, QueryClientProvider} from "react-query";
import { z } from "zod";


import {ACard} from "@atiautomacao/ati-ui-library";
import {
    Container,
    TextField,
    InputLabel,
    FormHelperText,
} from "@mui/material";
import Box from "@mui/material/Box";

import {
    FindAlarmSeverityByIdReactQuery,
    SaveAlarmSeverityReactQuery
} from "./AlarmSeverityReactQuery";
import {AlarmSeverityProps} from "../../../Shared/Types/AlarmSeverity";
import {SystemRoutes} from "../../../Utils/RouteUtils";
import {HeaderMenu} from "../HeaderMenu";
import {useSnackbar} from "notistack";
import {validateHexadecimal} from "../../../Utils/RegexUtils";

export const AlarmSeverityHomeForm = () => {
    const location = useLocation();
    const { enqueueSnackbar } = useSnackbar();

    const id = location.state?.id as string;

    const [alarmSeverityName, setAlarmSeverityName] = useState<string>("");
    const [alarmSeverityColor, setAlarmSeverityColor] = useState<string>("");
    const [alarmSeverityLevel, setAlarmSeverityLevel] = useState<number>(-1);
    const alarmSeveritySchema = z.object({
        id: z.number().nullable(),
        name: z
            .string()
            .min(1, "O nome da severidade do alarme é obrigatório")
            .max(40, "O nome da severidade do alarme deve ter no máximo 40 caracteres"),
        color: z
            .string()
            .min(1, "A cor da severidade do alarme é obrigatória")
            .max(6, "A cor da severidade do alarme deve ter no máximo 6 caracteres")
            .regex(/^[0-9A-Fa-f]{6}$/, "A cor deve ser um hexadecimal válido de 6 dígitos"),
    });
    const stringSchema = z.string()

    const mutationSave = SaveAlarmSeverityReactQuery();
    const mutationFindById = FindAlarmSeverityByIdReactQuery();
    const navigate = useNavigate();

    useEffect(() => {
        if(id){
            mutationFindById.mutate(Number(id), {
                onSuccess: (data) => {
                    let alarmSeverity = data?.data as AlarmSeverityProps;
                    setAlarmSeverityName(alarmSeverity.name);
                    setAlarmSeverityColor(alarmSeverity.color.trim());
                    setAlarmSeverityLevel(alarmSeverity.level);
                }
            });
        }
    }, []);

    function handleSave() {
        let newAlarmSeverity = {
            id: id != null ? Number(id) : null,
            name: alarmSeverityName.trim(),
            color: alarmSeverityColor.replace(/#/g, "").trim(),
            level: alarmSeverityLevel,
        };

        const result = alarmSeveritySchema.safeParse(newAlarmSeverity);

        mutationSave.mutate(newAlarmSeverity, {
                    onSuccess: () => {
                        navigate(SystemRoutes.SETTINGS_ALARM_SEVERITY);
                    },
                });

        // if (!result.success) {
        //     const errors = result.error.format();
        //     if (errors.name?._errors) {
        //         enqueueSnackbar(errors.name._errors[0], { variant: "error" });
        //     }
        //     if (errors.color?._errors) {
        //         enqueueSnackbar(errors.color._errors[0], { variant: "error" });
        //     }
        // } else {
        //     mutationSave.mutate(newAlarmSeverity, {
        //         onSuccess: () => {
        //             navigate(SystemRoutes.SETTINGS_ALARM_SEVERITY);
        //         },
        //     });
        // }
    }

    return (
        <>
            <HeaderMenu isOnSave={true} handleSave={handleSave} systemRoutes={SystemRoutes.SETTINGS_ALARM_SEVERITY}/>
            <Box>
                <ACard>
                    <Container style={{marginLeft: -10, display: 'flex', flexDirection: "column", alignItems: 'left', justifyContent: 'left', columnGap: 30}}>
                        <div style={{width: '100%'}}>
                            <Box style={{marginBottom: 20}}>
                                <InputLabel id="type-name">Nome</InputLabel>
                                <TextField
                                    error={alarmSeverityName === ""}
                                    fullWidth
                                    id="type-name"
                                    variant="standard"
                                    placeholder={"Nome da severidade"}
                                    onChange={(value) => setAlarmSeverityName(value.target.value)}
                                    value={alarmSeverityName}
                                />
                                {
                                    (!stringSchema.min(1).safeParse(alarmSeverityName).success &&
                                    <FormHelperText id="my-helper-text" style={{color:"#d70909"}}>Campo Obrigatório.</FormHelperText>)
                                    ||
                                    (!stringSchema.max(40).safeParse(alarmSeverityName).success &&
                                    <FormHelperText id="my-helper-text" style={{color:"#d70909"}}>Campo deve ter no máximo 40 caracteres.</FormHelperText>)
                                }
                            </Box>
                        </div>

                        <Box style={{marginBottom: 20}}>
                            <InputLabel id="type-color">Cor</InputLabel>
                            <Box style={{display: "flex", flexDirection: 'row', justifyContent: "space-between"}}>
                                <TextField
                                    error={alarmSeverityColor === ""}
                                    fullWidth
                                    id="type-color-type"
                                    variant="standard"
                                    type="color"
                                    placeholder={"Nome da cor"}
                                    onChange={(value) => setAlarmSeverityColor(value.target.value)}
                                    value={alarmSeverityColor.includes("#") ? `${alarmSeverityColor}` : `#${alarmSeverityColor}`}
                                    style={{width: 24}}
                                />
                                <TextField
                                    error={alarmSeverityColor === ""}
                                    fullWidth
                                    id="type-color"
                                    variant="standard"
                                    placeholder={"Nome da cor"}
                                    onChange={(value) => setAlarmSeverityColor(value.target.value)}
                                    value={alarmSeverityColor.includes("#") ? `${alarmSeverityColor}` : `#${alarmSeverityColor}`}
                                    style={{color: `#${alarmSeverityColor}`}}

                                />
                            </Box>
                            {
                                (!stringSchema.min(1).safeParse(alarmSeverityColor).success &&
                                    <FormHelperText id="my-helper-text" style={{color:"#d70909"}}>Campo Obrigatório.</FormHelperText>)
                                ||
                                (!validateHexadecimal(alarmSeverityColor) && <FormHelperText id="my-helper-text" style={{color:"#d70909"}}>Campo deve ter um hexadecimal válido.</FormHelperText>)
                                ||
                                (!stringSchema.max(7).safeParse(alarmSeverityColor).success &&
                                    <FormHelperText id="my-helper-text" style={{color:"#d70909"}}>Campo deve ter no máximo 6 caracteres.</FormHelperText>)
                            }
                        </Box>
                    </Container>
                </ACard>
            </Box>
        </>
    )
}

export function AlarmSeverityHomePageForm() {
    const queryClient = new QueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <AlarmSeverityHomeForm />
        </QueryClientProvider>
    )
}